module.exports = __webpack_public_path__ + "img/kurse.8a2edd8e.svg";